<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
    <div class="flex justify-end">
        <button class="button primary-button mr-2" (click)="onLinkMultipleRawMaterials()">
            Añadir materias primas en bloque
        </button>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
        <app-loader></app-loader>
    }
    @else {
        @if (finalProducts && finalProducts.length > 0) {
            <nz-table #basicTable [nzData]="finalProducts" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading"
                nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
                [nzScroll]="{ y: (tableHeight || 0) + 'px' }">
                <thead>
                    <tr>
                        <th nzWidth="50px">Nº</th>
                        <th>Artículo</th>
                        <th>Lote</th>
                        <th>Cantidad a producir</th>
                        <th>Formatos asignados</th>
                        <th>Materias primas asginadas</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @for(finalProduct of basicTable.data; track idx; let idx = $index){
                    <tr>
                        <td>{{ idx+1 }}</td>
                        <td>{{ finalProduct.article?.name }}</td>
                        <td>{{ finalProduct.articleBatch?.batchNumber }}</td>
                        <td>
                            {{finalProducts[idx].quantityToProduce | number:'1.0-2'}} {{getDisplayUnit()}}
                        </td>
                        <td>{{ getFinalProductPackagingsCount(finalProduct.id!) }}</td>
                        <td>
                            @if(finalProduct.article?.usePackagings && finalProducts[idx].packagings?.length){
                                <span nz-tooltip nzTooltipTitle="Materias primas de los paquetes">
                                    {{ getFinalProductRawMaterialsCount(finalProduct.id!) }}
                                    <span nz-icon nzType="info-circle" nzTheme="outline" class="mr-1"></span>
                                </span>
                            } @else {
                                {{ getFinalProductRawMaterialsCount(finalProduct.id!) }}
                            }
                        </td>
                        <td>
                            <div class="flex align-middle justify-center">
                                @if(packagingsByFinalProductId.get(finalProduct.id!)?.length! > 0){
                                <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                    [nzTooltipTitle]="'Ver y añadir formatos'" nzTooltipPlacement="bottom" nz-tooltip
                                    (click)="showPackagings(finalProduct)">
                                    <span nz-icon nzType="appstore-add"></span>
                                </button>
                                } @else {
                                <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                    [nzTooltipTitle]="'Ver y añadir materias primas'" nzTooltipPlacement="bottom" nz-tooltip
                                    (click)="onLinkRawMaterials(finalProduct)">
                                    <span nz-icon nzType="appstore-add"></span>
                                </button>
                                }
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
        }
        @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }    
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button class="button secondary-button  mr-2" (click)="handleClose()">
            Cerrar
        </button>
    </div>
</div>
